import React from "react";
import clsx from "clsx";
import { FaCar, FaExclamationTriangle, FaPhone } from "react-icons/fa";
import {FaMessage} from "react-icons/fa6";
import {formatCaseCard} from "../utils/dashboard-formatters.js";
import {useDashboardContext} from "../context/dashboard-context.js";
import {getAttendanceType} from "../utils/dashboard-filters.js";
import {vehicleIcon} from "../../../../components/vehicle-icon/vehicle-icon.js";

const AttendanceCard = ({attendance, serverDate, canShowGarrisonPanel}) => {
    const {cardInteractions, cardInformationHandlers} = useDashboardContext();
    const status = getAttendanceType(attendance);
    const interactionCard = {
        type: "attendance",
        id: attendance.attendanceId,
        state: status,
        item: attendance,
    };
    const VehicleIcon = vehicleIcon[attendance.vehicleType] ?? FaCar;
    const elapsed = (() => {
        if (!attendance.startValue && !attendance.start) return "";
        const startDate = new Date(attendance.startValue ?? attendance.start);
        const endDate = serverDate ? new Date(serverDate) : new Date();
        if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return "";
        const diffMinutes = Math.max(0, Math.floor((endDate.getTime() - startDate.getTime()) / 60000));
        const days = Math.floor(diffMinutes / 1440);
        const hours = Math.floor((diffMinutes % 1440) / 60);
        const minutes = diffMinutes % 60;
        if (days > 0) return `${String(days).padStart(2, "0")}d ${String(hours).padStart(2, "0")}h`;
        if (hours > 0) return `${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}min`;
        return `${String(minutes).padStart(2, "0")}min`;
    })();
    const isNextCall = attendance.lastUser === "SISTEMA" && Boolean(attendance.ramalIdentify);
    const isDelay = attendance.attendanceType === "delayed";
    const blinkPriorityIcon = (isDelay ? <FaExclamationTriangle className="mb-1" /> : '');

    return (
        <div
            id={`attendancePanel_${attendance.attendanceId}`}
            className={clsx(canShowGarrisonPanel ? "" : "w-[24%]", "attendance-cards-panel", cardInteractions.getDropClassName(interactionCard))}
            data-card-type="attendance"
            data-card-state={status}
            data-card-id={attendance.attendanceId}
            data-attendance-id={attendance.attendanceId}
            data-garrison-id={attendance.garrisonId ?? ""}
            data-dispatch-id={attendance.dispatchId ?? ""}
            data-nature={attendance.nature ?? ""}
            data-nature-text={attendance.natureText ?? ""}
            data-place={attendance.place ?? ""}
            draggable
            onClick={() => cardInteractions.selectCard(interactionCard)}
            onDoubleClick={() => cardInformationHandlers.openAttendanceInformation(attendance)}
            onContextMenu={event => cardInteractions.openContextMenu(event, interactionCard)}
            onDragStart={event => cardInteractions.handleDragStart(event, interactionCard)}
            onDragEnd={cardInteractions.handleDragEnd}
            onDragOver={event => cardInteractions.handleDragOver(event, interactionCard)}
            onDragLeave={() => cardInteractions.handleDragLeave(interactionCard)}
            onDrop={event => cardInteractions.handleDrop(event, interactionCard)}
        >
            <div
                id={`attendancePanelSelection_${attendance.attendanceId}`}
                className={clsx("attendances-card", status, cardInteractions.getSelectionClassName(interactionCard))}
            >
                <div className={`panel-heading-card ${status}`} />
                <div className={`panel-title-card ${status}`}>
                    <div className="flex-card">
                        <div className="card-panel-body pull-left title-card-attendance">
                            <span className="flex items-center gap-2">
                                {attendance.natureText ? <span>{attendance.natureText}</span> : null}
                                {isNextCall ? <FaPhone size={13} style={{fontSize: "13px"}}/> : null}
                                {attendance.hasChat ? <FaMessage className={attendance.hasUnreadChat ? "chat-notification" : ""} size={13} title="Chat do atendimento"/> : null}
                            </span>
                        </div>
                        <div className="card-panel-body">
                            <span className="float-end">{elapsed}</span>
                        </div>
                    </div>
                </div>
                <div className={`attendances-panel-body ${status}`}>
                    <div className="flex-card">
                        <div className="float-end card-panel-body min-w-0 flex-1">
                            {attendance.citizenName && <span className="ramal-identify-card">SOS acionado por <label>{attendance.citizenName}</label></span>}
                            {attendance.place && <span className={"truncate"}>{formatCaseCard(attendance.place)}</span>}
                            {isNextCall && <span className="ramal-identify-card"><label>{attendance.ramalIdentify}</label> - gerado automaticamente</span>}
                        </div>
                        <div className="pull-left card-panel-body shrink-0">
                            {attendance.priority ? (
                                <div className={`code-card-priority ${isDelay ? "blink" : ""}`} style={{color: attendance.priorityColor}}>
                                    <b className="float-end flex gap-1 items-center">
                                        {String(attendance.priority).toUpperCase()}
                                        {blinkPriorityIcon}
                                    </b>
                                </div>
                            ) : ""}
                        </div>
                    </div>
                    <div className={`flex-card ${canShowGarrisonPanel ? "" : "flex-card-placeholder"}`}>
                        <div className={"float-end card-panel-body"}>
                            {attendance.sectors && attendance.sectors !== -1 ? <span>{formatCaseCard(attendance.sectors)}</span> : ""}
                        </div>
                    </div>
                    <div className="flex-card">
                        <div className="float-end card-panel-body flex items-center justify-center">
                            <span className={"mr-1"}>{attendance.vehicleType && <VehicleIcon size={14}/>}</span>
                            {attendance.garrisonIdentification ? (
                                <span>
                                    {attendance.garrisonIdentification}
                                    {attendance.vehiclePlate ? ` | ${attendance.vehiclePlate}` : ""}
                                </span>
                            ) : ""}
                        </div>
                        <div className="pull-left card-panel-body">
                            <span className="font-number-card float-end">{attendance.protocol}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AttendanceCard;
